import React, { useLayoutEffect } from 'react';
import type { CSSProperties } from 'react';

import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';

import { CREATING, DELAY, FINISHED, FROZEN, PAUSED, PLAYING } from 'state';
import { Button, Typography } from 'antd';

type props = {
  busted: boolean;
  // delay: number;
};

const BustBanner: React.FC<props> = ({ busted }) => {
  const commonStyles = {
    position: 'fixed',
    zIndex: 99999,
  } as CSSProperties;

  const pausedStyles = {
    top: '50vh',
    right: 0,
    transformOrigin: 'right top',
    transform: 'rotate(90deg) translateX(50%)',
    backgroundColor: '#fadb14',
    padding: '5px 10px',
    fontSize: '18px',
  } as CSSProperties;

  const creatingStyles = {
    top: 0,
    left: 0,
    width: '100%',
    // marginTop: '2vh',
    // height: '98vh',
    height: '100vh',
    backgroundColor: 'rgba(255,255,255,0.16)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    // backdropFilter: 'blur(2px)',
    // WebkitBackdropFilter: 'blur(2px)',
    // blur: '22px',
  } as CSSProperties;

  const overlayStyles = {
    ...commonStyles,
    ...(busted === true ? creatingStyles : commonStyles),
  };
  // const delayMultipleMinutes = status === DELAY && delay > 1;
  // const delayOneMinute = status === DELAY && delay === 1;

  return (
    <div style={overlayStyles}>
      <span
        style={{
          color: '#1f1f1f',
        }}
      >
        {busted === true && (
          <div
            style={{
              backgroundColor: 'rgba(246,39,39,0.24)',
              backdropFilter: 'blur(2px)',
              WebkitBackdropFilter: 'blur(2px)',
              borderRadius: '15px',
              padding: '160px',
            }}
          >
            {/*<div*/}
            {/*  style={{*/}
            {/*    display: 'flex',*/}
            {/*    alignItems: 'center',*/}
            {/*    gap: 8,*/}
            {/*    width: '600px',*/}
            {/*  }}*/}
            {/*>*/}
            <div style={{ width: '600px' }}>
              <WarningOutlined style={{ marginRight: 10 }} />
              {/*<Typography.Title level={2} style={{ margin: 0 }}>*/}
              {/*  You went bust!*/}
              {/*</Typography.Title>*/}
              Your account has been liquidated due to loss of all AUM. For
              learning purposes, you will been reassigned to a fresh account.
              Use this opportunity to apply improved risk management strategies.
            </div>
            {/*</div>*/}
            <Button
              size={'large'}
              ghost
              type={'default'}
              onClick={() => (window.location.href = '/dashboard')}
              style={{
                display: 'block',
                marginTop: '30px',
                // border: '20px',
              }}
            >
              {/*<Typography.Title level={4}>Exit session</Typography.Title>*/}
              <div style={{ fontWeight: 'bold' }}>Exit session</div>
            </Button>
          </div>
        )}
      </span>
    </div>
  );
};

export default BustBanner;
